<template>
  <el-dialog id="dialogServer" :title="serverLabel" :visible="visible" @close="onClose">
    <el-form id="formServer" label-position="right" label-width="150px">
      <el-form-item :label="serverLabel">
        <proxy-servers-select
          v-model="newIdServer"
          :id-media-core="idMediaCore"
          :id-dvr-server="idDvrServer"
        />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button id="closeServer" @click="onClose">Отменить</el-button>
      <el-button id="submitServer" :loading="loading" type="primary" @click="onSave">{{ confirmButtonText }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ProxyServersSelect from "@/components/Server/feature/ProxyServersSelect";
import { MEDIA_CORE } from "@/core/helpers/const";

export default {
  name: "ProxyServerDialog",
  components: { ProxyServersSelect },
  props: {
    idServer: {
      type: Number,
      default: null,
    },
    idMediaCore: {
      type: Number,
      default: null,
    },
    idDvrServer: {
      type: Number,
      default: null,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    confirmButtonText: {
      type: String,
      default: "Сохранить",
    },
    loading: {
      type: Boolean,
    },
  },
  data() {
    return {
      newIdServer: null,
    };
  },
  computed: {
    serverLabel() {
      return this.idMediaCore === MEDIA_CORE.VK3 ? "MCore" : "Прокси-сервер";
    },
  },
  watch: {
    idServer: {
      immediate: true,
      handler(idServer) {
        this.newIdServer = idServer;
      },
    },
  },
  methods: {
    onSave() {
      this.$emit("save", this.newIdServer);
    },
    onClose() {
      this.$emit("close");
    },
  },
};
</script>
